import http from "../../services/api";
import queryString from "query-string";
import store from "../index";
import * as types from "./../types/usuario";
import customQueryStringify from "../../helpers/queryString";

export const autenticarUsuario = async (cpf, password) => {
  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.USUARIO_LOADING, payload: true });
    http.post(`/api/v2/app/auth`, { cpf, password }).then(
      ({ data }) => {
        store.dispatch({ type: types.USUARIO_SET, payload: data });
        localStorage.setItem("token", data.token);
        store.dispatch({ type: types.USUARIO_LOADING, payload: false });
        resolve();
      },
      (e) => {
        store.dispatch({ type: types.USUARIO_LOADING, payload: false });
        reject(e ? e.response.data : "Não foi possível efetuar o login");
      }
    );
  });
};

export async function LoadPacientes() {
  store.dispatch({ type: types.USUARIO_LOADING, payload: true });

  return await http
    .get(`/api/v2/app/cliente?plano=true`)
    .then(({ data }) => {
      store.dispatch({ type: types.USUARIO_SET, payload: data });

      return data;
    })
    .catch((error) => Promise.reject(error))
    .finally(() => {
      store.dispatch({ type: types.USUARIO_LOADING, payload: false });
    });
}

export function UpdadeCadastro(item) {
  store.dispatch({ type: types.USUARIO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http.patch(`api/v2/app/cliente`, item).then(
      (response) => {
        store.dispatch([
          { type: types.USUARIO_SET, payload: response.data },
          { type: types.USUARIO_LOADING, payload: false },
        ]);
        resolve();
      },
      (e) => {
        reject(
          e.response.data ?? {
            message: "Não foi possível atualizar seu cadastro",
          }
        );
        store.dispatch([{ type: types.USUARIO_LOADING, payload: false }]);
      }
    );
  });
}

export function CriarCadastroCliente(dados) {
  store.dispatch({ type: types.CHANGE_USUARIO_LOADING, payload: true });

  return new Promise((resolve, reject) => {
    http
      .post("/api/v2/app/cliente", dados)
      .then((response) => {
        const data = response.data;
        store.dispatch([
          { type: types.CHANGE_USUARIO_LOADING, payload: false },
        ]);
        resolve(response.data);
      })
      .catch((e) => {
        reject(
          e.response?.data ? e.response?.data : "Não foi possível prosseguir"
        );
      });
  });
}

export function EfetuarLoginApp(credentials) {
  store.dispatch({ type: types.CHANGE_USUARIO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http
      .post("/api/v2/app/auth", credentials)
      .then((response) => {
        const data = response.data;
        store.dispatch([
          { type: types.CHANGE_USUARIO_LOADING, payload: false },
          { type: types.CHANGE_CLIENTE_DATA, pasyload: data.cliente },
        ]);
        resolve(response.data);
      })
      .catch((e) => {
        reject(
          e.response?.data ? e.response?.data : "Não foi possível prosseguir"
        );
      });
  });
}

export function LoadClienteData(qryStr) {
  const _qry = customQueryStringify(qryStr);

  store.dispatch({ type: types.CHANGE_USUARIO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http
      .get(`/api/v2/app/cliente?${_qry}`)
      .then((response) => {
        store.dispatch([
          { type: types.CHANGE_USUARIO_LOADING, payload: false },
          { type: types.CHANGE_CLIENTE_DADOS_LOAD, payload: response.data },
        ]);
        resolve(response.data);
      })
      .catch((e) => {
        store.dispatch({ type: types.CHANGE_USUARIO_LOADING, payload: false });
        reject(
          e.response?.data ? e.response?.data : "Não foi possível prosseguir"
        );
      });
  });
}

export function LoadDadosCartao(qryStr) {
  const _qry = customQueryStringify(qryStr);

  store.dispatch({
    type: types.CHANGE_DADOS_ASSINATURA_LOADING,
    payload: true,
  });
  return new Promise((resolve, reject) => {
    http
      .get(`/api/v2/app/assinatura?${_qry}`)
      .then((response) => {
        store.dispatch([
          { type: types.CHANGE_DADOS_ASSINATURA_LOADING, payload: false },
          { type: types.CHANGE_DADOS_ASSINATURA_LOAD, payload: response.data },
        ]);
        resolve(response.data);
      })
      .catch((e) => {
        store.dispatch({
          type: types.CHANGE_DADOS_ASSINATURA_LOADING,
          payload: false,
        });
        reject(
          e.response?.data ? e.response?.data : "Não foi possível prosseguir"
        );
      });
  });
}

export function LoadPlanoCliente(qryStr) {
  const _qry = customQueryStringify(qryStr);

  store.dispatch({ type: types.CHANGE_PLANO_CLIENTE_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http
      .get(`/api/v2/app/cliente?${_qry}`)
      .then((response) => {
        store.dispatch([
          { type: types.CHANGE_PLANO_CLIENTE_LOADING, payload: false },
          { type: types.CHANGE_CLIENTE_PLANOS, payload: response.data.plano },
        ]);
        resolve(response.data);
      })
      .catch((e) => {
        store.dispatch({
          type: types.CHANGE_PLANO_CLIENTE_LOADING,
          payload: false,
        });
        reject(
          e.response?.data ? e.response?.data : "Não foi possível prosseguir"
        );
      });
  });
}

export function EnviarCodigoValidacaoSenha(cpf) {
  store.dispatch({ type: types.CHANGE_USUARIO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http
      .post("/api/v2/app/cliente/redefinir-senha/solicitar", cpf)
      .then((response) => {
        const data = response.data;
        store.dispatch([
          { type: types.CHANGE_USUARIO_LOADING, payload: false },
        ]);
        resolve(response.data);
      })
      .catch((e) => {
        store.dispatch([
          { type: types.CHANGE_USUARIO_LOADING, payload: false },
        ]);
        reject(
          e.response?.data ? e.response?.data : "Não foi possível prosseguir"
        );
      });
  });
}

export function ValidarCodigoResetSenhaAction(data) {
  store.dispatch({ type: types.CHANGE_USUARIO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http
      .post("/api/v2/app/cliente/redefinir-senha/validar", data)
      .then((response) => {
        const data = response.data;
        store.dispatch([
          { type: types.CHANGE_USUARIO_LOADING, payload: false },
        ]);
        resolve(response.data);
      })
      .catch((e) => {
        store.dispatch([
          { type: types.CHANGE_USUARIO_LOADING, payload: false },
        ]);
        reject(e.response ? e.response : "Não foi possível prosseguir");
      });
  });
}

export function RedefinirSenhaTokenAcion(data) {
  store.dispatch({ type: types.CHANGE_USUARIO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http
      .patch("/api/v2/app/cliente/redefinir-senha", data)
      .then((response) => {
        const data = response.data;
        store.dispatch([
          { type: types.CHANGE_USUARIO_LOADING, payload: false },
        ]);
        resolve(response.data);
      })
      .catch((e) => {
        store.dispatch([
          { type: types.CHANGE_USUARIO_LOADING, payload: false },
        ]);
        reject(e.response ? e.response : "Não foi possível prosseguir");
      });
  });
}

/**
 * Informações da verificação de uma possível atualização disponível do plano
 * do cliente (e caso o sistema não poderá fazer automaticamente).
 * @typedef VerifyClientePlanoVerification
 * @type {object}
 * @property {boolean} update - Informa se há uma atualização disponível do plano do cliente.
 * @property {number} [newPlanoId] - ID do plano novo disponível do cliente (se `update === true`).
 * @property {string} [formaPagamento] - Forma de pagamento do plano novo disponível do cliente (se `update === true`).
 * @property {number} [empresaId] - ID da nova empresa do cliente (se `update === true`).
 * @property {boolean} [redirectToPayment] - Informa se deve redirecionar o cliente para a página de pagamento (se `update === true`).
 * @property {number} [diaVencimento] - Dia de vencimento da assinatura definida na proposta.
 */

/**
 * Método responsável por verificar se há uma atualização do plano do cliente
 * oriundo de uma venda do sistema de vendas. Se há uma atualização e for de
 * uma venda PJ, o sistema fará a atualização e retorna a nova assinatura.
 * Se for de uma venda PF e necessário pagamento, irá retornar as informações
 * para redirecionar o cliente.
 *
 * Se o status for `200`, retornará informações sobre a verificação.
 *
 * Se o status for `201`, significa que o sistema realizou a atualização e
 * retornará a nova assinatura do cliente.
 *
 * @param {AbortController} [abortController]
 * @returns {Promise<VerifyClientePlanoVerification|object>}
 */
export async function VerifyClientePlano(abortController = undefined) {
  return await http
    .patch("/api/v2/app/assinatura/verify", undefined, {
      signal: abortController?.signal,
    })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
